<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" :ariaLabel="$t('configurations.link_group')">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{$t('configurations.link_group')}}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div 
        class="form-wrapper p-4 overflow-x-hidden"
        ref="containerSelect"
        style="max-height: 40vh"
        :style="{'height':heightContainerSelect}"
        >
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">
            <div ref="selectRef">
              <AccessibleElSelect
                v-model="form.groupId"
                prop="groupId"
                :options="groupsForAccessibleSelect"
                :withFormItem="true"
                :isMultiple="true"
                :isDisabled="isLoadingSelect"
                :group="true"
                @visible-change="onExpand"
                @change="onChangeInput"
                id-prefix="userlinkgroupsdialog"
              >
                <template slot="label">{{$t('app.groups')}}</template>
              </AccessibleElSelect>
            </div>
          </div>
          
        </el-form>
      </div>
    </template>
    <template slot="footer">
        <base-button mode="secondary-phantom-blue"
            class="w-full"
          v-if="!isAllSelected" 
          :disabled="!isLoadedData || isLoadingSelect || isEmptyList" 
          :text="$t('app.select_all')" 
          @click="handleSelectAll" 
          :loading="isLoadingSelect"
          />
        <base-button v-else :text="$t('app.unselect_all')" mode="secondary-phantom-blue"
            class="w-full"
          @click="handleUnSelectAll"
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect || isEmptyList"
          />
          <div class="w-48 "></div>
        <base-button @click="toggleDialog" mode="secondary-phantom-blue" :text="$t('app.cancel')" 
            class="w-full"
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect"/>
        <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.accept')" @click="apply" 
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect"/>
    </template>
  </base-dialog-button>
</template>

<script>
import BaseDialogButton from './base/BaseDialogButton.vue'
import { getGroupsSimple } from '@/services/configurations/groups/getGroupsSimple'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

export default
{
  name: 'user-link-groups-dialog',
  components: {
    BaseDialogButton,
    AccessibleElSelect
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 64,
      isOpen: this.dialogOpen,
      form: {
        groupId: []
      },
      groups: [],
      isLoadedData: false,
      loadingActionSelect: false,
      loadingActionUnSelect: false
    }
  },
  mounted: async function () {
    this.isLoadedData = false
    const data = await getGroupsSimple({ idUsuario: this.$route.params.id })
    if (data.blnError === true) {
      this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
    } else {
      data.Respuesta.forEach(row => {
        this.groups.push({ id: row.IdGrupo, value: row.Nombre, group: row.Tipo })
      })
    }
    this.isLoadedData = true
  },
  computed: {
    groupsForAccessibleSelect: function () {
      if (!this.isEmptyList) {
        return this.listaGroupsGrouping.map(group => ({
          label: group.label,
          options: group.options.map(option => ({
            id: option.value,
            name: option.label,
            value: option.value
          }))
        }))
      }
      return []
    },
    listaGroupsGrouping () {
      if (!this.isEmptyList) {
        const options = []
        this.groups.forEach(x => {
          if (options.filter(y => y.label === x.group).length === 0) {
            options.push(
              { label: x.group, options: [] }
            )
          }
        })
        this.groups.forEach(x => {
          const index = options.map(x => x.label).indexOf(x.group)
          options[index].options.push(
            {
              value: x.id,
              label: x.value,
            }
          )
        })
        return options
      }
      return []
    },
    isEmptyList: function () {
      return this.groups === undefined || this.groups === null || this.groups.length === 0
    },
    isLoadingSelect: function () {
      return this.loadingActionUnSelect || this.loadingActionSelect
    },
    isAllSelected: function () {
      if (this.groups.length === this.form.groupId.length) return true
      else return false
    },
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
  },
  methods: {
    onExpand (value) {
      this.onChangeInput()
      if (value) {
        setTimeout(() => {
          const elementsScrollBar = document.getElementsByClassName('el-scrollbar')
          this.heightSelect = elementsScrollBar[elementsScrollBar.length - 1]?.clientHeight
        }, 100)
      } else {
        this.heightSelect = 0
      }
    },
    onChangeInput () {
      setTimeout(() => {
        this.heightInput = this.$refs.selectRef.clientHeight
      }, 100)
    },
    toggleDialog: function () {
      if (this.dialogOpen && this.isLoadingSelect) return
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
      this.form.groupId = []
    },
    apply: function () {
      this.isOpen = !this.isOpen
      this.$emit('applyDialog', this.form.groupId)
      this.form.groupId = []
    },
    handleSelectAll: async function () {
      // this.form.location = []
      await this.handleUnSelectAll()
      this.loadingActionSelect = true
      this.groups.forEach(element => {
        setTimeout(() => {
          this.form.groupId.push(element.id)
          if (this.form.groupId.length === this.groups.length) {
            this.loadingActionSelect = false
            this.loadingActionUnSelect = false
          }
        }, 100)
      })
    },
    handleUnSelectAll: async function () {
      this.loadingActionUnSelect = true
      const staticLength = this.form.groupId.length
      for (let index = 0; index < staticLength; index++) {
        setTimeout(() => {
          this.form.groupId.pop()
          if (this.form.groupId.length === 0) this.loadingActionUnSelect = false
        }, 100)
      }
      // this.form.location = []
    }
  }
}
</script>

<style lang="scss" scoped></style>
